// @flow

import * as React from 'react';

type Props = {
  name: string,
  matched: boolean,
  metaData: ?Array<string>,
  onMetaDataClick: (metaDataIndex: string) => mixed
};

export default class AgentQueryRulesResult extends React.PureComponent<Props> {
  render() {
    const metaDataNode = (
      this.props.metaData && this.props.metaData.length > 0
        ? this.props.metaData.map((metaData, index) => (
          <span
            className="AgentQueryRulesResultComponent__MetaData__Data"
            key={metaData}
            data-index={index}
            onClick={this.handleMetaDataClick}
          >
            {metaData}
          </span>
        ))
        : <span>No metadata</span>
    );

    const className = (
      this.props.matched
        ? 'AgentQueryRulesResultComponent--matched'
        : 'AgentQueryRulesResultComponent'
    );

    return (
      <div className={className}>
        <div className="AgentQueryRulesResultComponent__Name">
          {this.props.name}
        </div>
        <div className="AgentQueryRulesResultComponent__MetaData">
          {metaDataNode}
        </div>
      </div>
    );
  }

  handleMetaDataClick = (evt: SyntheticMouseEvent<HTMLSpanElement>) => {
    evt.preventDefault();

    if (!(evt.target instanceof HTMLSpanElement)) {
      return;
    }

    const index = parseInt(evt.target.getAttribute("data-index"), 10);

    if (!this.props.metaData) {
      return;
    }

    return this.props.onMetaDataClick(this.props.metaData[index]);
  };
}
